'use client'

import posthog from 'posthog-js'
import { PostHogProvider as PHProvider, usePostHog } from 'posthog-js/react'
import { Suspense, useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

export function PostHogProvider({ children }) {
    useEffect(() => {
        posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
            api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
            ui_host: 'https://eu.posthog.com',
            // persistence: 'memory', // Use memory persistence for initial setup
            capture_pageview: false, // We capture pageviews manually
            capture_pageleave: true, // Enable pageleave capture
            capture_exceptions: true, // This enables capturing exceptions
            debug: false,
        })
    }, [])

    return (
        <PHProvider client={posthog}>
            <SuspendedPostHogPageView />
            {children}
        </PHProvider>
    )
}

function PostHogPageView() {
    const pathname = usePathname()
    const searchParams = useSearchParams()
    const posthog = usePostHog()

    useEffect(() => {
        if (pathname && posthog) {
            let url = window.origin + pathname
            const search = searchParams.toString()
            if (search) {
                url += '?' + search
            }
            posthog.capture('$pageview', { $current_url: url })
        }
    }, [pathname, searchParams, posthog])

    return null
}

function SuspendedPostHogPageView() {
    return (
        <Suspense fallback={null}>
            <PostHogPageView />
        </Suspense>
    )
}
